import { definedValue } from '../index';
import { twoSplit, parseFormattedNumber, parseFormattedPrice, readProductDimensions, SEPARATORS } from '../parsers/formatParsers';
import { PRODUCT_PAGE } from '../../pages/pageConstants';
const { HYPHEN, COMMA } = SEPARATORS;

const pathFromSwitcherElement = (node) => definedValue(node?.parentNode?.getAttribute('href'), '#');
const pathFromPaginationElement = (node) => definedValue(node?.getAttribute('href'), '#');

const gridSelector = 'grid';
const gridItemSelector = '.grid-item .product-card';

const readProductPrice = (domPrice) => {
  const productType = domPrice?.getAttribute('data-details');
  const [formatType, currency] = twoSplit(productType, HYPHEN);
  const price = parseFormattedPrice(domPrice?.textContent, formatType);
  return {price, currency};
};

const readDataId = (domProduct) => {
  const idsString = domProduct?.getAttribute('data-id');
  const ids = idsString?.split(HYPHEN);
  return { id: +ids[0], ownerId: +ids[1], phone: ids[2] };
};

const readWidthAndLength = (domWH) => {
  const text = definedValue(domWH?.textContent?.trim(), '');
  const wh = domWH?.getAttribute('data-details');
  let [length, width] = readProductDimensions(text);
  const [widthUnit, lengthUnit] = twoSplit(wh, '-');
  width = +width?.replace(widthUnit, '');
  length = +length?.replace(lengthUnit, '');
  return {width, length, widthUnit, lengthUnit};
};

const readLocation = (domLocation) => {
  const text = definedValue(domLocation?.textContent?.trim(), '');
  const [city, countryCode] = text.split(COMMA);
  return {
    city: definedValue(city?.trim(), ''),
    countryCode: definedValue(countryCode?.trim(), '')
  };
};

const parseProductFromDom = (domProduct, productType) => {
  const title = domProduct.querySelector('.product-card__body-title');
  const img = domProduct.querySelector('img.product-card__header-img');
  const logo = domProduct.querySelector('.product-card__footer-logo img');
  const row1 = domProduct.querySelector('.product-card__body-text--row1');
  const row2 = domProduct.querySelector('.product-card__body-text--row2');
  const row3 = domProduct.querySelector('.product-card__body-text--row3');
  const row4 = domProduct.querySelector('.product-card__body-text--row4');
  const { id, ownerId, phone } = readDataId(domProduct);
  const { price, currency } = readProductPrice(row1);
  const {width, length, widthUnit, lengthUnit} = readWidthAndLength(row2);
  const { city, countryCode } = readLocation(row3);
  const owner = definedValue(row4?.textContent?.trim(), '');
  const titleText = title?.textContent?.trim();
  const imageURL = img?.src;
  const ownerLogo = definedValue(logo?.src, '');
  return {
    city,
    countryCode,
    currency,
    title: titleText,
    id,
    imageURL,
    length,
    lengthUnit,
    owner,
    ownerId,
    ownerLogo,
    price: parseFormattedNumber(price[0]),
    phone,
    type: productType,
    width,
    widthUnit,
  };
};

const getProductGrids = (productPage) => {
  const grids = productPage?.getElementsByClassName(gridSelector);
  return grids ? Array.from(grids) : [];
};

const getProductGridItems = (grid, productType) => {
  const gridItems = grid.querySelectorAll(gridItemSelector);
  return gridItems.length ? Array.from(gridItems).map((product) => parseProductFromDom(product, productType)) : [];
};

const getProductsFromDom = () => {
  const productPage = document.getElementById(PRODUCT_PAGE);
  const container = productPage?.querySelector('[data-product-type]');
  const productType = definedValue(container?.getAttribute('data-product-type'), '');
  const grids = getProductGrids(productPage);
  if (grids.length === 0) {
    return [];
  }
  const productGrids = grids.map((grid) => {
    const productCards = getProductGridItems(grid, productType);
    return { grid, productCards };
  });
  return productGrids;
};

const parseProductsFromDom = () => {
  const productGrids = getProductsFromDom();
  return productGrids.reduce((acc, { productCards }) => {
    return acc.concat(productCards);
  }, []);
};


export { pathFromSwitcherElement, pathFromPaginationElement, getProductsFromDom, parseProductsFromDom };
